import React from 'react';
import {Link} from "react-router-dom";

const EnrollmentPage = () => (
    <div className='content'>
        <h2>How to Enroll</h2>
        <h3 className='newsBulletin'>
            Our Hummingbirds & Chickadees Class (2&frac12;-4 year-olds) is currently FULL for the 2021-22 school year.
            If you would like to join our waitlist:
            <ul>
                <li>
                    Email us with your contact info, child's name, and date of birth.
                </li>
                <li>
                    -or-  Send us your Registration Form.
                </li>
                <li>
                    We will confirm that you are on the waitlist via email.
                </li>
            </ul>

        </h3>

        <h3>Step 1: Schedule a visit</h3>
        <p>
            Call 206-853-5670 or email info@littlenest.org to schedule.
        </p>
        <h3>Step 2: Fill Out a <a href="/images/LittleNestRegForm21-22.pdf">Registration Form</a>.</h3>
        <p>
            You can send in your registration form whenever you like.
            Mail it to 10743 14th Ave NE, Seattle, WA 98125 or drop it off at Little Nest.
        </p>
        <h3>Step 3: Wait for Notification</h3>
        <p>
            We will notify you of your successful enrollment as soon as we're sure we have room for you.
        </p>
    </div>
);

export default EnrollmentPage;



// WEBPACK FOOTER //
// ./src/components/EnrollmentPage.js